import { memo } from 'react';
import { arrayOf, node, oneOfType } from 'prop-types';

export const Title = ({ children = null, ...props }) => <h2 {...props}>{children}</h2>;

Title.propTypes = {
  children: oneOfType([node, arrayOf(node)]),
};

export const MemoizedTitle = memo(Title);
